import React from "react";
import { PropTypes } from "prop-types";
import { List as AntList, Row, Col, Button } from "antd";
import { ReportsService } from "services";
import { List } from "immutable";

class ReportsPage extends React.Component {
    state = {
        list: new List([])
    };
    componentDidMount() {
        ReportsService.getReportList().then(_ => {
            if (_.data && _.data.results && _.data.results.length > 0) {
                this.setState({
                    list: new List(_.data.results)
                });
            }
        });
    }
    render() {
        return (
            <Row className={"p-5"}>
                <Col span={24}>
                    <Button icon={"arrow-left"} onClick={() => this.props.history.replace("/app/inbox")}>{"Back"}</Button>
                </Col>
                <Col span={24}>
                    <AntList
                        header={<h1>Reports</h1>}
                        itemLayout={"horizontal"}
                        dataSource={this.state.list}
                        renderItem={item => (
                            <AntList.Item
                                // actions={[
                                //     <a
                                //         key="view"
                                //         onClick={() =>
                                //             this.props.history.push(
                                //                 "/app/reports/" + item.id,
                                //                 {
                                //                     ...this.props.location
                                //                         .state,
                                //                     reports: { name: item.name }
                                //                 }
                                //             )
                                //         }
                                //     >
                                //         View
                                //     </a>
                                // ]}
                            >
                                <AntList.Item.Meta title={<a onClick={() => this.props.history.push(
                                    "/app/reports/" + item.id,
                                    {
                                        ...this.props.location
                                            .state,
                                        reports: { name: item.name }
                                    }
                                )}>{item.name}</a>} />
                            </AntList.Item>
                        )}
                    />
                </Col>
            </Row>
        );
    }
}

ReportsPage.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object
};

export default ReportsPage;
